import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es material actualizado?',
  a: 'Sí. El Megapack está actualizado a 2026, con jurisprudencia, modelos y herramientas de IA jurídica vigentes. Además, al adquirirlo tenés acceso a las futuras actualizaciones sin costo adicional.'
}, {
  q: '¿Cómo recibo el acceso?',
  a: 'Apenas se acredita el pago recibís automáticamente el acceso a todo el material digital: los 10 módulos, los 5 bonos premium y los cientos de recursos listos para usar.'
}, {
  q: '¿Sirve si recién me recibí?',
  a: 'Absolutamente. El Megapack está pensado para todos los niveles. Los modelos, checklists y estrategias listas para aplicar te dan la seguridad para tomar tus primeros casos sin improvisar.'
}, {
  q: '¿Qué métodos de pago hay?',
  a: 'Podés abonar mediante Mercado Pago, tarjeta de crédito/débito o transferencia bancaria. Todo el proceso es 100% seguro.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, tenés 7 días de garantía de satisfacción. Si el Megapack no cumple tus expectativas, te devolvemos el dinero.'
}, {
  q: '¿Necesito conocimientos previos de IA?',
  a: 'No. El módulo de IA Jurídica Aplicada incluye prompts, automatizaciones y sistemas listos para usar, explicados de forma simple para incorporarlos a tu práctica desde el primer día.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-legal-800" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-88">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-89">
          {faqs.map((faq, idx) => <div key={idx} className="bg-legal-900 border border-legal-700 rounded-lg overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-gold-500/50" data-id="element-91">
                <span className="text-lg font-medium text-white" data-id="element-92">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="p-6 pt-0 text-slate-400 leading-relaxed border-t border-legal-800" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};